import {
  TeamSafetySummary,
  TeamSafetyMember,
  TeamSafetyAutoExcluded,
  TeamSafetyManualExcluded,
} from "../../../models";
import { getPayPeriod } from "./getPayPeriod";

const member = (r: any): TeamSafetyMember => ({
  driverId: r.driver_id,
  firstName: r.first_name,
  lastName: r.last_name,
  weightedScore: r.weighted_score ?? null,
  reportCount: r.report_count ?? 0,
  totalDriveMinutes: r.total_drive_minutes ?? 0,
  totalDriveMiles: r.total_drive_miles ?? 0,
});

const auto = (r: any): TeamSafetyAutoExcluded => ({
  driverId: r.driver_id,
  firstName: r.first_name,
  lastName: r.last_name,
});

const manual = (r: any): TeamSafetyManualExcluded => ({
  driverId: r.driver_id,
  firstName: r.first_name,
  lastName: r.last_name,
  weightedScore: r.weighted_score ?? null,
  reason: r.reason ?? "",
  setBy: r.set_by,
  setAt: r.set_at,
});

export const getTeamSafetySummary = (data: any): TeamSafetySummary => ({
  payPeriod: getPayPeriod(data.pay_period),
  method: data.method,
  teamScore: data.team_score ?? null,
  simpleAverage: data.simple_average ?? null,
  deltaVsPrev: data.delta_vs_prev ?? null,
  driverCount: data.driver_count ?? 0,
  provisional: !!data.provisional,
  locked: !!data.locked,
  lockedAt: data.locked_at || undefined,
  lockedBy: data.locked_by || undefined,
  included: (data.included || []).map(member),
  autoExcluded: (data.auto_excluded || []).map(auto),
  manuallyExcluded: (data.manually_excluded || []).map(manual),
});
